export const setPage = (instance, lastVisitedPage, claimTypeValue, inOrAfterSubWizard, setPageIsSet) => {
  let pageToSet = -1;
  let gotToSubWizard = false;
  const newLastVisitedPages = [];
  if (lastVisitedPage.length) {
    if (lastVisitedPage[lastVisitedPage.length - 1] === lastVisitedPage[lastVisitedPage.length - 2]) {
      if (lastVisitedPage[lastVisitedPage.length - 1] === 'propertyConnectPage') {
        lastVisitedPage = lastVisitedPage.slice(0, -1);
        lastVisitedPage[lastVisitedPage.length - 1] = 'propertyEmergencyPage';
      }
      newLastVisitedPages.push(lastVisitedPage[lastVisitedPage.length - 1]);
      lastVisitedPage.pop();
    }
    const firstWizardPage = inOrAfterSubWizard ? lastVisitedPage.findIndex((p) => p.includes('_page')) : 0;
    lastVisitedPage.forEach((page, index) => {
      newLastVisitedPages.splice(newLastVisitedPages.length - 1, 0, page);
      if (index === lastVisitedPage.length - 1 && (lastVisitedPage[lastVisitedPage.length - 1] === lastVisitedPage[lastVisitedPage.length - 2])) {
        setPageIsSet(true);
      } else {
        setTimeout(() => {
          if (inOrAfterSubWizard && !gotToSubWizard && !page.includes('_page')) {
            // do nothing because this pages have already been set
          } else if (index === firstWizardPage || pageToSet > -1) {
            gotToSubWizard = true;
            pageToSet = instance.pages.findIndex((p) => p.path === page);
            if (pageToSet < 0) {
              setPageIsSet(true);
              return;
            }
            if (page.startsWith('review')) {
              window.sessionStorage.setItem('resumeReview', 'true');
            }
            instance.setPage(pageToSet);
            if (instance.pages[index].path === instance.pages[lastVisitedPage.length - 1].path) {
              setPageIsSet(true);
            }
          }
        }, (index * 600));
      }
    });
  }
  if (pageToSet < 0 && newLastVisitedPages.length < 1) {
    instance.setPage(1);
    setPageIsSet(true);
    if (claimTypeValue === 'property') {
      return ['propertyEmergencyPage'];
    }
    if (claimTypeValue === 'abonly') {
      return ['abonly_page1'];
    }
    return ['auto_page1'];
  }
  return newLastVisitedPages;
};

export const getClaimType = (claimTypeObj) => {
  let claimTypeValue = 'auto';
  if (claimTypeObj?.claim_type === 'Home') {
    claimTypeValue = 'property';
  } else if (claimTypeObj?.vehicle?.policySystemId === 'injuryOnly') {
    claimTypeValue = 'abonly';
  }
  return claimTypeValue;
};

export const hasLossCause = (data) => {
  let nested = 'auto';
  if (data?.claim_type?.claim_type === 'Home') {
    nested = 'property';
  }
  if (data?.claim_type?.vehicle?.policySystemId === 'injuryOnly') {
    nested = 'abonly';
  }
  return !!data?.[nested]?.data?.lossCause?.value;
};

export const clearPages = (instancePages, newPagesArray) => {
  newPagesArray.forEach((newPageArray) => {
    const pageToDelete = instancePages.findIndex((instancePage) => instancePage.path === newPageArray);
    if (pageToDelete === -1) { // if its -1, it means that there's no such page
      newPagesArray = newPagesArray.filter((page) => page !== newPageArray);
    }
  });
  return newPagesArray;
};

const sortPages = (pagesToSort, claimTypeValue) => {
  const sortedArrayAuto = ['auto_page1', 'auto_page2', 'auto_page3', 'auto_page4', 'auto_page5', 'auto_page6', 'reviewAutoPage'];
  const sortedArrayProperty = ['propertyEmergencyPage', 'propertyConnectPage', 'property_page1', 'property_page2', 'property_page3', 'property_page4', 'property_page5', 'property_page6', 'reviewPropertyPage'];
  const sortedArrayAbOnly = ['abonly_page1', 'abonly_page2', 'abonly_page3', 'abonly_page4', 'abonly_page5', 'abonly_page6', 'reviewAutoPage'];
  let sortedPagesArray = [];
  switch (claimTypeValue) {
    case 'auto':
      sortedPagesArray = [...pagesToSort.sort((a, b) => sortedArrayAuto.indexOf(a) - sortedArrayAuto.indexOf(b))];
      break;
    case 'property':
      sortedPagesArray = [...pagesToSort.sort((a, b) => sortedArrayProperty.indexOf(a) - sortedArrayProperty.indexOf(b))];
      break;
    case 'abonly':
      sortedPagesArray = [...pagesToSort.sort((a, b) => sortedArrayAbOnly.indexOf(a) - sortedArrayAbOnly.indexOf(b))];
      break;
    default:
      break;
  }
  return sortedPagesArray;
};

export const reorderPages = (pages, page, seenPages, claimTypeValue) => {
  const newlastVisitedPageArray = [...clearPages(pages, seenPages)];
  const pageIndex = newlastVisitedPageArray.findIndex((p) => p === page.path);
  if (pageIndex === -1) {
    newlastVisitedPageArray.push(page.path);
  }
  const sortedPagesArray = sortPages(newlastVisitedPageArray, claimTypeValue);
  sortedPagesArray.push(page.path);
  return sortedPagesArray;
};

export const getRouteUrl = (pageLabel, claimType) => {
  const routerMap = {
    'Type of claim': 'start-claim',
    'What happened': claimType === 'Vehicle' ? 'auto/what-happened' : 'property/what-happened',
    'Injuries in your vehicle': 'auto/people-involved',
    'People in your vehicle': 'auto/people-involved',
    'Your vehicle': 'auto/vehicle-damages',
    'People in the other vehicles': 'auto/third-party-injuries',
    'People who were injured': 'auto/people-involved',
    'Cyclist injuries': 'auto/third-party-injuries',
    'Pedestrian injuries': 'auto/third-party-injuries',
    'People who are injured': 'auto/people-involved',
    'Injuries in the occupied vehicle': 'auto/people-involved',
    'What are the injuries': 'auto/injuries',
    'The vehicle that caused injury': 'auto/vehicle-caused-injury',
    'Occupied vehicle': 'auto/vehicle-occupied',
    'Additional details': claimType === 'Vehicle' ? 'auto/additional-details' : 'property/additional-details',
    'Emergency Services': 'property/emergency-services',
    'Connect with us': claimType === 'Vehicle' ? 'auto/repair-shop-appointment-connect' : 'property/emergency-service-connect',
    'Property usage': 'property/property-usage',
    'Interior damages': 'property/interior-damages',
    'Exterior damages': 'property/exterior-damages',
    'Damage to belongings': 'property/belongings-damage',
    'Your belongings': 'property/belongings-damage',
    'Let\'s take care of your vehicle': 'auto/certified-repair-shop',
    'Select a certified repair shop': 'auto/repair-shop-locator',
    'Let\'s choose an appointment': 'auto/repair-choose-appointment',
    'Your repair shop appointment details': 'auto/repair-shop-appointment-details',
    'Let’s get you on your way': 'auto/services-enterprise-uber',
    'Uber voucher': 'auto/send-uber-voucher',
    'Get ready to ride': 'auto/send-uber-voucher',
    'Enterprise rental': 'auto/services-enterprise-rental',
    'Schedule your Enterprise rental': 'auto/schedule-rental',
    'Your rental request': 'auto/rental-request',
    'Review your services': 'auto/services-review',
    'Auto Submit claim': 'auto/submit-claim',
    'Property submit claim': 'property/submit-claim',
    'Your claim has been successfully submitted': 'auto/submit-claim',
    Review: claimType === 'Vehicle' ? 'auto/review' : 'property/review',
  };
  return routerMap[pageLabel];
};

export const routesArray = ['start-claim', 'auto/repair-shop-locator', 'auto/certified-repair-shop', 'property/belongings-damage', 'property/exterior-damages', 'property/interior-damages', 'property/property-usage', 'auto/repair-shop-appointment-connect', 'property/emergency-service-connect', 'property/emergency-services', 'property/additional-details', 'auto/additional-details', 'auto/vehicle-occupied', 'auto/injuries', 'auto/vehicle-caused-injury', 'auto/third-party-injuries', 'auto/third-party-injuries', 'auto/what-happened', 'property/what-happened', 'auto/vehicle-damages', 'auto/people-involved'];
